import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronRightIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { primaryColorL1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const itemButtonCss = "ids9j0g";
const ItemButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(itemButtonCss, props.className)} />);
const iconBackgroundCss = "i7l6lab";
const IconBackground = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconBackgroundCss, props.className)} />;
});
const textContainerCss = "t1gv1pqk";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
export const CardButton = ({
  icon,
  header,
  body,
  onClick
}) => <ItemButton onClick={onClick}>
    <IconBackground>
      {icon}
    </IconBackground>
    <TextContainer>
      <BodyText weight="bold">
        {header}
      </BodyText>
      <BodyText color="muted" size="medium">
        {body}
      </BodyText>
    </TextContainer>
    <ArrowChevronRightIcon color={primaryColorL1} />
  </ItemButton>;

require("./card_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./card_button.js");